import { Checkbox, Input } from "antd";
import React from "react";

function VitalConfigurationTable({ data, checked, handleVitalCheckUnCheck }) {
  const handleVitalCheckBox = (e, idx, manualItem = null) => {
    const selectedItem = manualItem || data?.[idx];
    const isChecked = e.target.checked;
    const itemCode = selectedItem.vitalCode;

    let checkedItems = [...checked] || [];

    const findItemByCode = (code) =>
      code === "HI" || code === "WE"
        ? { vitalCode: code, name: code === "HI" ? "Height" : "Weight" }
        : data.find((item) => item.vitalCode === code);

    const isCheckedInList = (code) =>
      checkedItems.some((i) => i.vitalCode === code);

    const addIfNotExists = (code) => {
      const item = findItemByCode(code);
      if (item && !isCheckedInList(code)) checkedItems.push(item);
    };

    const removeByCode = (code) => {
      if (code === "BPS" || code === "BPD") {
        checkedItems = checkedItems.filter(
          (i) => i.vitalCode !== "BPS" && i.vitalCode !== "BPD"
        );
        return;
      }
      checkedItems = checkedItems.filter((i) => i.vitalCode !== code);
    };

    if (isChecked) {
      addIfNotExists(itemCode);

      if (itemCode === "BPS") {
        addIfNotExists("BPD");
      } else if (itemCode === "BPD") {
        addIfNotExists("BPS");
      } else if (itemCode === "BMI") {
        addIfNotExists("HI");
        addIfNotExists("WE");
      } else if (itemCode === "HI" || itemCode === "WE") {
        const hasHeight = itemCode === "HI" ? true : isCheckedInList("HI");
        const hasWeight = itemCode === "WE" ? true : isCheckedInList("WE");
        if (hasHeight && hasWeight) {
          addIfNotExists("BMI");
          addIfNotExists("HI");
          addIfNotExists("WE");
        } else if (hasWeight) {
          addIfNotExists("BMI");
          addIfNotExists("HI");
          addIfNotExists("WE");
        } else if (hasHeight) {
          addIfNotExists("WE");
          addIfNotExists("HI");
          addIfNotExists("BMI");
        }
      }
    } else {
      removeByCode(itemCode);

      if (itemCode === "HI" || itemCode === "WE") {
        const hasWeight = isCheckedInList("WE");
        if (!hasWeight) {
          removeByCode("BMI");
          removeByCode("WE");
        }
      } else if (itemCode === "BMI") {
        removeByCode("HI");
        removeByCode("WE");
      }
    }

    handleVitalCheckUnCheck(checkedItems);
  };

  return (
    <>
      <div>
        <div
          className={`min-w-full ${
            data ? "w-max" : "flex-1"
          } rounded-lg flex justify-center py-2`}
        >
          <table className="w-full mx-2 overflow-scroll relative">
            <thead className="sticky top-0 bg-white z-10">
              <tr>
                <th>Select</th>
                <th>Vitals</th>
                <th>Normal Range</th>
                <th>Min Abnormal Range</th>
                <th>Max Abnormal Range</th>
                <th>Critical Range</th>
              </tr>
              <tr className="bg-[#DEF3F2]">
                <td className="py-0.5" colSpan={12}></td>
              </tr>
            </thead>
            <tbody className="text-center">
              {data?.map((item, idx) => {
                const shouldShow =
                  item.vitalCode !== "HI" && item.vitalCode !== "WE";

                return (
                  <React.Fragment key={idx}>
                    <tr>
                      <td>
                        <Checkbox
                          checked={checked?.some(
                            (vitalItem) =>
                              vitalItem.vitalCode === item.vitalCode
                          )}
                          name={item.vitalCode}
                          onChange={(e) => handleVitalCheckBox(e, idx)}
                        />
                      </td>
                      <td>{item.name}</td>

                      {/* Normal Range */}
                      <td>
                        {shouldShow && (
                          <div className="flex justify-between">
                            <Input
                              style={{ width: "55px", marginRight: "7px" }}
                              value={item.minimumNormalRange}
                            />
                            <Input
                              style={{ width: "55px" }}
                              value={item.maximumNormalRange}
                            />
                          </div>
                        )}
                      </td>

                      {/* Min Abnormal Range */}
                      <td>
                        {shouldShow && (
                          <div className="flex justify-between">
                            <Input
                              style={{ width: "55px", marginRight: "7px" }}
                              value={item.minimumAbnormalRange}
                            />
                            <Input
                              style={{ width: "55px" }}
                              value={item.minimumNormalRange - 1}
                              disabled
                            />
                          </div>
                        )}
                      </td>

                      {/* Max Abnormal Range */}
                      <td>
                        {shouldShow && (
                          <div className="flex justify-evenly">
                            <Input
                              style={{ width: "55px", marginRight: "7px" }}
                              value={item.maximumNormalRange + 1}
                              disabled
                            />
                            <Input
                              style={{ width: "55px" }}
                              value={item.maximumAbnormalRange}
                            />
                          </div>
                        )}
                      </td>

                      {/* Critical Range */}
                      <td>
                        {shouldShow && (
                          <div style={{ width: "max-content" }}>
                            <label>
                              {`( < ${item.minimumAbnormalRange} OR > ${item.maximumAbnormalRange} )`}
                            </label>
                          </div>
                        )}
                      </td>
                    </tr>
                    <tr className="bg-[#DEF3F2]">
                      <td className="py-0.5" colSpan={12}></td>
                    </tr>
                  </React.Fragment>
                );
              })}

              <tr>
                <td>
                  <Checkbox
                    checked={checked?.some(
                      (vitalItem) => vitalItem.vitalCode === "HI"
                    )}
                    name={"HI"}
                    onChange={(e) =>
                      handleVitalCheckBox(e, null, {
                        vitalCode: "HI",
                        name: "Height",
                      })
                    }
                  />
                </td>
                <td>Height (cm)</td>
              </tr>

              <tr className="bg-[#DEF3F2]">
                <td className="py-0.5" colSpan={12}></td>
              </tr>

              <tr>
                <td>
                  <Checkbox
                    checked={checked?.some(
                      (vitalItem) => vitalItem.vitalCode === "WE"
                    )}
                    name={"WE"}
                    onChange={(e) =>
                      handleVitalCheckBox(e, null, {
                        vitalCode: "WE",
                        name: "Weight",
                      })
                    }
                  />
                </td>
                <td>Weight (Kg)</td>
              </tr>
            </tbody>
          </table>
        </div>
      </div>
    </>
  );
}

export default VitalConfigurationTable;
